.gg{z-index:2;}